module.exports = __webpack_public_path__ + "img/fondo1.815d04c1.png";